import { CompositeDecorator } from "draft-js";

import { CalleeFieldSpan, InvalidCalleeFieldSpan } from "./CalleeFieldSpan";

const decorator = new CompositeDecorator([
  {
    strategy: function (contentBlock, callback, contentState) {
      contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();
        if (entityKey === null) {
          return false;
        }
        const entity = contentState.getEntity(entityKey);

        return (
          entity.getType() === "CALLEE_FIELD" && entity.getData().isInvalid
        );
      }, callback);
    },
    component: InvalidCalleeFieldSpan
  },
  {
    strategy: function (contentBlock, callback, contentState) {
      contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();
        if (entityKey === null) {
          return false;
        }
        return contentState.getEntity(entityKey).getType() === "CALLEE_FIELD";
      }, callback);
    },
    component: CalleeFieldSpan
  }
]);

export default decorator;
